import { jsx } from "react/jsx-runtime";
import FolderIcon from "@mui/icons-material/Folder";
import { validateTidalLicense } from "../../base/index.js";
function Folder(props) {
  return /* @__PURE__ */ jsx(
    FolderIcon,
    {
      "data-testid": "Folder",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Folder",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Folder.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Folder"
};
validateTidalLicense();
export {
  Folder
};
//# sourceMappingURL=Folder.js.map
